import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import consultarProtocoloSelector from "../store/consultarProtocolo.selectors";
import consultarProtocoloActions from "../store/consultarProtocolo.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import Button from '@material-ui/core/Button';
import RedeSIMHeader from '../../redeSIM.header';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.ConsultarProtocolo",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Analise Órgão",
        dataName: "IdAnaliseOrgao",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Órgão",
        dataName: "Orgao",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Serviço",
        dataName: "Servico",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Data Início",
        dataName: "DataInicio",
        show: true,
        type: "date",
        onlyDate: true,
        removeFilter: true
      },
      {
        fieldName: "Status Análise",
        dataName: "StatusAnalise",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Nome Fiscal",
        dataName: "NomeCompletoUsuario",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Data Final",
        dataName: "DataFinal",
        show: true,
        type: "date",
        onlyDate: true,
        removeFilter: true
      },
    ];

    const actions = [
      {
        title: "Visualizar Análise",
        icon: "fas fa-eye",
        onClick: async dataItem => {
          this.props.consultarProtocoloActions.viewAnalise(dataItem);
        }
      }
    ];

    const order = [
      { fieldName: "Protocolo", dataName: "Protocolo", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  onClose(){
    this.props.consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]);
    this.props.consultarProtocoloActions.setGridConsultarProtocolo([]);
  }

  render() {
    const { consultarProtocolo } = this.props.consultarProtocoloSelector;
    const { GridConsultarProtocolo, HeaderDocumento, ViewAnaliseModalToggle } = consultarProtocolo;

    return (
      <>
      <RedeSIMHeader selector={HeaderDocumento} />
      <StaticGrid {...this.config} itens={GridConsultarProtocolo.asMutable()}></StaticGrid>
        <div style={{ textAlign: 'right' }}>
          <Button variant="outlined" color="primary" onClick={this.onClose}>
                    <i className={"mr-1 fa fa-angle-double-left"} />{" "}
                    {"Voltar"}
          </Button>
        </div>
      </>
    );
  }
}

export default connect({
  actions: {
    consultarProtocoloActions
  },
  selectors: {
    consultarProtocoloSelector
  }
})(Container);
